import { render } from "./Hall.vue?vue&type=template&id=656b058f&scoped=true&bindings={\"audio\":\"data\",\"muted\":\"data\",\"nextStep\":\"options\",\"backToStreet\":\"options\",\"playSound\":\"options\",\"pauseSound\":\"options\",\"switchSound\":\"options\"}"
import script from "./Hall.vue?vue&type=script&lang=js"
export * from "./Hall.vue?vue&type=script&lang=js"

import "./Hall.vue?vue&type=style&index=0&id=656b058f&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-656b058f"

export default script